import styled, { css } from 'styled-components'
import { CloseIcon } from '@sainsburys-tech/bolt-icons'
import { visibleScrollBar } from '../../../helpers/StyledWrappers.styles'
import Image from '../../../helpers/Image/Image'
import { ExpandedItemBodyCopy, ItemBodyCopy } from './types'

export const StyledItemCarousel = styled.div`
  display: flex;
  height: 100%;
  ${(props) =>
    css`
      gap: ${props.theme.size.spacing.lg};
      padding-bottom: ${props.theme.size.spacing.md};
    `}
  text-decoration: none;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  ${visibleScrollBar}
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-top: ${(props) => props.theme.size.spacing.md};
  }
`

export const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 300px;

  h3 {
    margin: ${(props) => props.theme.size.spacing.md} 0;
  }
`
export const StyledReadMore = styled.span`
  font-weight: bold;
  padding-bottom: 1rem;

  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`

export const StyledExpandedItemImage = styled(Image)`
  padding-top: ${(props) => props.theme.size.spacing.md};
  height: 100%;
  aspect-ratio: 2/1;
`

export const StyledExpandedItemHeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-top: ${(props) => props.theme.size.spacing.md};
  }
  h3 {
    margin-bottom: ${(props) => props.theme.size.spacing.sm};
  }
`

export const StyledCloseButton = styled(CloseIcon)`
  width: 20px;
  height: 20px;
  :hover {
    cursor: pointer;
  }
`

export const StyledItemBodyCopy = styled.p<ItemBodyCopy>`
  margin-bottom: ${(props) => props.isSainsburys && '0'};
`

export const StyledExpandedItemBodyCopy = styled.p<ExpandedItemBodyCopy>`
  overflow-y: auto;
  max-height: ${(props) => (props.hasImage ? '200px' : '250px')};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    max-height: ${(props) => (props.hasImage ? '250px' : '300px')};
    margin-bottom: ${(props) => (props.hasImage ? 0 : props.theme.size.spacing.lg)};
  }
  ${(props) =>
    !props.hasImage &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        max-height: 350px;
      }
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        max-height: 500px;
      }
    `}
`

export const StyledCtaAndImageWrapper = styled.div<ExpandedItemBodyCopy>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.hasImage ? 'space-between' : 'flex-start')};
  height: 100%;
`
